<script lang="ts">
    import type { BooleanSetting } from "..";

    export let setting: BooleanSetting;
</script>

<!----------------------------------------------------------------------------->

<input id={setting.id} type="checkbox" bind:checked={setting.value}>

<!----------------------------------------------------------------------------->

<style></style>
